export function isTaskNameDisabled({ taskDetails, userData }) {

    if (taskDetails?.libraryTaskID) return true;

    const isAdmin = userData?.isAdmin === "Yes";
    const isApprover = userData?._id && taskDetails?.approverID === userData._id;

    return !(isAdmin || isApprover);
}


export function isTaskDescriptionDisabled({ taskDetails, userData }) {
    const isAdmin = userData?.isAdmin === "Yes";
    const isApprover = userData?._id && taskDetails?.approverID === userData._id;

    return !(isAdmin || isApprover);

}


export function isModuleDisabled({ taskDetails, userData }) {

    if (taskDetails?.libraryTaskID) return true;

    const isAdmin = userData?.isAdmin === "Yes";
    const isApprover = userData?._id && taskDetails?.approverID === userData._id;

    return !(isAdmin || isApprover);
}

export function isInputDisabled({ taskDetails, userData, roles = [], lockOnLibraryTask=false , userCheck = null}) {

    if (userCheck && userCheck === userData?._id) {
        return false;
    }

    if (lockOnLibraryTask && taskDetails?.libraryTaskID) return true;

    for (const role of roles) {
        if (role === "Admin" && userData?.isAdmin === "Yes") return false;
        if (role === "approver" && userData?.responsibilities === "approver") return false;
        if (role === "preparer" && userData?.responsibilities === "preparer") return false;
        if (role === "task-preparer" && taskDetails?.assigneeIDs?.includes(userData?._id)) return false;

        if (role === "task-approver") {
            if (!taskDetails?.approverID) {
                if (userData?.responsibilities === "approver") return false;
            } else if (taskDetails.approverID === userData?._id) {
                return false;
            }
        }

    }

    return true;
}
